/* Obtain backend URL to make requests */
export const env = process.env.REACT_APP_BACKEND_DOMAIN_URL;
export const envTest = process.env.REACT_APP_BACKEND_DOMAIN_URL_TEST;
export const envStaging = process.env.REACT_APP_BACKEND_DOMAIN_URL_STAGING;
export const envProd = process.env.REACT_APP_BACKEND_DOMAIN_URL_PROD;
export const purchasePageProd = process.env.REACT_APP_PURCHASE_PAGE_PROD;
export const purchasePageTest = process.env.REACT_APP_PURCHASE_PAGE_TEST;
export const geolocationEnv =
  "https://us-central1-care-api-prod.cloudfunctions.net/geolocation";
